
export const BLUETOOTH_DENIED = "bluetooth_denied";
export const BLUETOOTH_UNAVAILABLE = 'bluetooth_unavailable';

export const NOTIFICATION_DENIED = "notification_denied";


export const requestBluetoothPermission = async () => {
    return "granted";
};